export default __webpack_public_path__ + "static/media/candidate.work_learn_tab.culinary.7449a326.jpg";